import http from '../../../../libs/http'
import config from '../../../../config/shops'
export default (payload = {}) => http.post(`${config.api}/orders/consolidate/requests`, payload)
